import { createApiMutationHook } from '@/hooks/use-api-mutation';
import { post } from '@/libs/http';
import { CustomChatRoomUrlReq, CustomChatRoomUrlRes } from '@/types/api/chat/custom-chat-room-url.d';

export const postChatRoomUrl = ({ params }: { params: CustomChatRoomUrlReq; }) =>
  post<CustomChatRoomUrlRes>('/pay/api/v1/custom/chat/room/url', params);

export const usePostChatRoomUrl = createApiMutationHook(postChatRoomUrl);

